import { Dialog, styled } from '@mui/material';

const CustomDialog = styled(Dialog)`
  & .MuiDialog-container {
    padding-top: 64px;
  }

  & .MuiDialog-paper {
    overflow: hidden;
  }
`;

export default CustomDialog;
